export default "__VITE_ASSET__DCjENsrA__"